const articles = ['a', 'an', 'the']
const conjunctions = ['for', 'and', 'nor', 'but', 'or', 'yet', 'so']
const prepositions = [
  'with', 'at', 'from', 'into','upon', 'of', 'to', 'in', 'for',
  'on', 'by', 'like', 'over', 'plus', 'but', 'up', 'down', 'off', 'near',
]

export const replaceCharsWithSpace = (str: string): string =>
  str.replace(/[^\p{L}\p{N}&/\\]/gu, ' ').replace(/(\s\s+)/g, ' ')
export const capitalizeFirstLetter = (str: string): string =>
  str.charAt(0).toUpperCase() + str.substring(1)
export const normalizeStr = (str: string): string =>
  str.toLowerCase().trim()
export const shouldCapitalize = (word: string, fullWordList: string[], posWithinStr: number): boolean => {
  if ((posWithinStr == 0) || (posWithinStr == fullWordList.length - 1)) {
    return true
  }

  return !(articles.includes(word) || conjunctions.includes(word) || prepositions.includes(word))
}
export const toTitleCase = (str: string): string => {
  str = replaceCharsWithSpace(str)
  str = normalizeStr(str)

  let words = str.split(' ')
    
  if (words.length <= 2) { // Strings less than 3 words long should always have first words capitalized
    words = words.map(w => capitalizeFirstLetter(w))
  }
  else {
    for (let i = 0; i < words.length; i++) {
      words[i] = (shouldCapitalize(words[i], words, i) ? capitalizeFirstLetter(words[i]) : words[i])
    }
  }

  return words.join(' ')
}
